module.exports = __webpack_public_path__ + "img/EgyptTechSlingerS_ua.7196fb2e.webp";